import { privateApi } from 'services';
import {
    PhoneNumber,
    AvailablePhoneNumber,
    PurchasePhoneNumberRequest,
    SearchAvailablePhoneNumbersRequest,
} from './types';

const fetchPhoneNumbers = (businessAccountId: string): Promise<PhoneNumber[]> =>
    privateApi.get<PhoneNumber[]>(`business-accounts/${businessAccountId}/bird/phone-numbers`);

const fetchPhoneNumber = (businessAccountId: string, phoneNumberId: string): Promise<PhoneNumber> =>
    privateApi.get<PhoneNumber>(`business-accounts/${businessAccountId}/bird/phone-numbers/${phoneNumberId}`);

const searchAvailablePhoneNumbers = (
    businessAccountId: string,
    searchParams: SearchAvailablePhoneNumbersRequest,
): Promise<AvailablePhoneNumber[]> =>
    privateApi.post<AvailablePhoneNumber[]>(
        `business-accounts/${businessAccountId}/bird/phone-numbers/search-available`,
        searchParams,
    );

const purchasePhoneNumber = (
    businessAccountId: string,
    purchaseRequest: PurchasePhoneNumberRequest,
): Promise<PhoneNumber> =>
    privateApi.post<PhoneNumber>(`business-accounts/${businessAccountId}/bird/phone-numbers`, purchaseRequest);

const syncPhoneNumbers = (businessAccountId: string): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/bird/phone-numbers/sync`, {});

export const BirdPhoneNumbersGateway = {
    fetchPhoneNumbers,
    fetchPhoneNumber,
    searchAvailablePhoneNumbers,
    purchasePhoneNumber,
    syncPhoneNumbers,
};
